import { createStyles, rem } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  chatItem: {
    cursor: 'pointer',
    padding: '0.75rem 1rem',
    borderRadius: rem(8),
    marginBottom: rem(8),
    listStyle: 'none',
    transition: 'background-color 0.3s ease, transform 0.2s ease',

    '&:hover': {
      transform: 'scale(1.02)'
    }
  },

  light: {
    color: '#000000',

    '&:hover': {
      backgroundColor: '#CBD5E1'
    },

    '&.active': {
      backgroundColor: '#475569',
      color: '#FFFFFF',

      '&:hover': {
        backgroundColor: '#64748B'
      }
    }
  },

  dark: {
    color: '#FFFFFF',

    '&:hover': {
      backgroundColor: '#334155'
    },

    '&.active': {
      backgroundColor: '#D1E8FF',
      color: '#FFFFFF',

      '&:hover': {
        backgroundColor: '#A0C4FF'
      }
    }
  }
}));
